import { ApiStatus } from "src/config/enums/genericEnums";
import { BasicDataFilterConfigProp, TlnFilter } from "../interface";
import { PERMISSION, userRoles } from "src/config/constants/genericConstants";

export const queryResult = [
  {
    date: "2024-10-29",
    time: "175439",
    register: "1",
    transaction: "00000000109",
    cashier: "1",
    totalAmount: 3
  },
  {
    date: "2024-10-29",
    time: "180137",
    register: "1",
    transaction: "00000000114",
    cashier: "1",
    totalAmount: 2
  }
];

export const detailResult = [
  {
    date: "12/01/2024",
    transactionId: "00000000000000000068",
    itemId: "000000000000010100",
    upc: "10100",
    description: "PLACHOLDER FOR UNMATCHED GROCERY ITEMS",
    quantity: "1.00",
    price: "$3.49",
    department: "Grocery",
    taxable: "No",
    taxAmount: "0.00",
    recordQualifier: "5",
    tenderAmount: "0.00",
    tenderTypeCode: ""
  },
  {
    date: "12/01/2024",
    transactionId: "00000000000000000068",
    itemId: "000000000000010100",
    upc: "10100",
    description: "PLACHOLDER FOR UNMATCHED GROCERY ITEMS",
    quantity: "1.00",
    price: "$5.99",
    department: "Grocery",
    taxable: "No",
    taxAmount: "0.00",
    recordQualifier: "5",
    tenderAmount: "0.00",
    tenderTypeCode: ""
  }
];
export const itemTypes = [
  { id: "hasGiftCard", name: "giftCards" },
  { id: "hasCoupon", name: "coupons" },
  { id: "hasRefund", name: "refunds" },
  { id: "isVoid", name: "voids" }
];

export const masterDropdown = [
  {
    id: "1",
    name: "a",
    cashier: [
      {
        id: "1",
        name: "b",
        tenderType: [
          {
            id: "1",
            name: "c"
          }
        ]
      }
    ]
  },
  {
    id: "2",
    name: "b",
    cashier: [
      {
        id: "2",
        name: "c",
        tenderType: [
          {
            id: "2",
            name: "d"
          }
        ]
      }
    ]
  }
];

export const basicInitialTlnFilter: any = {
  lineItemType: ["1", "2"],
  fromDate: "",
  toDate: "",
  storeId: "",
  registers: [],
  cashiers: [],
  transactionId: "",
  upc: "",
  transactionTotal: false,
  lineItemAmount: "",
  tenderTypes: [],
  totalAmountMax: "",
  totalAmountMin: ""
};

export const options: any = {
  registerOptions: [
    { id: "1", name: "1" },
    { id: "2", name: "2" }
  ],
  cashierOptions: [
    { id: "1", name: "1" },
    { id: "2", name: "2" }
  ],
  tenderTypesOptions: [
    { id: "1", name: "1" },
    { id: "2", name: "2" }
  ],
  itemTypesOptions: [
    { id: "1", name: "1" },
    { id: "2", name: "2" }
  ]
};

export const callback = {
  updateItemAmount: () => {},
  updateAmountBetween: () => {},
  updateDate: () => {},
  updateTransactionNum: () => {},
  updateItemType: () => {},
  updateUpc: () => {},
  updateTransactionTotal: () => {},
  handleClear: () => {},
  handleTenderType: () => {},
  handleCashier: () => {},
  handleRegister: () => {},
  handleSubmit: () => {}
};

export const preloadedState: any = {
  auth: {
    data: {},
    status: "idle",
    error: "",
    storeID: "333",
    storeName: "",
    storeState: "",
    storeStateShort: ""
  },
  user: {
    configuration: userRoles.IO,
    isLoggedIn: false,
    user: {
      email: "test"
    },
    accessToken: undefined,
    sessionToken: undefined,
    idToken: undefined,
    permissions: [
      PERMISSION.VIEW_TRANSACTION_LOG_REPORT,
      PERMISSION.VIEW_TRANSACTION_LOG_REPORT_DETAIL_EXPORT,
      PERMISSION.VIEW_TRANSACTION_LOG_REPORT_DETAIL
    ]
  },
  transactionLogReport: {
    filters: {
      fromDate: "",
      toDate: "",
      storeId: "",
      registers: [],
      cashiers: [],
      transactionId: "",
      upc: "",
      transactionTotal: true,
      lineItemAmount: "",
      tenderTypes: [],
      lineItemType: [],
      totalAmountMin: "",
      totalAmountMax: ""
    },
    queryResult: {
      status: ApiStatus.IDLE,
      data: [],
      error: ""
    },
    itemTypes: {
      status: ApiStatus.IDLE,
      data: itemTypes,
      error: ""
    },
    masterDropdowns: {
      status: ApiStatus.IDLE,
      data: masterDropdown,
      error: ""
    },
    transationDetail: {
      status: ApiStatus.IDLE,
      data: {
        tableData: { sales: [], refunds: [] },
        consolidatedData: [{}]
      },
      error: ""
    }
  }
};

export const MockData: {
  basicInitialTlnFilter: TlnFilter;
  options: BasicDataFilterConfigProp["dropdowns"];
  callback: BasicDataFilterConfigProp["callback"];
  queryResult: any;
  itemTypes: any;
  masterDropdown: any;
  preloadedState: any;
  detailResult: any;
} = {
  preloadedState,
  queryResult,
  itemTypes,
  masterDropdown,
  basicInitialTlnFilter,
  options,
  callback,
  detailResult
};
